/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VisibilityConditionType = {
    Show: 'SHOW',
    Hide: 'HIDE'
} as const;
export type VisibilityConditionType = typeof VisibilityConditionType[keyof typeof VisibilityConditionType];


export function instanceOfVisibilityConditionType(value: any): boolean {
    for (const key in VisibilityConditionType) {
        if (Object.prototype.hasOwnProperty.call(VisibilityConditionType, key)) {
            if (VisibilityConditionType[key as keyof typeof VisibilityConditionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VisibilityConditionTypeFromJSON(json: any): VisibilityConditionType {
    return VisibilityConditionTypeFromJSONTyped(json, false);
}

export function VisibilityConditionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisibilityConditionType {
    return json as VisibilityConditionType;
}

export function VisibilityConditionTypeToJSON(value?: VisibilityConditionType | null): any {
    return value as any;
}

export function VisibilityConditionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): VisibilityConditionType {
    return value as VisibilityConditionType;
}

